/** Delivery zones — keys match public.cities.region and store_delivery_prices.region */
export const DELIVERY_REGIONS = [
  {
    key: "west_bank",
    labelAr: "الضفة الغربية",
    labelEn: "West Bank",
  },
  {
    key: "inside",
    labelAr: "مناطق الداخل",
    labelEn: "Inside",
  },
  {
    key: "jerusalem",
    labelAr: "ضواحي القدس",
    labelEn: "Jerusalem suburbs",
  },
  {
    key: "abu_ghosh",
    labelAr: "ابو غوش وضواحيها",
    labelEn: "Abu Ghosh and suburbs",
  },
  {
    key: "eilat",
    labelAr: "ايلات",
    labelEn: "Eilat",
  },
  {
    key: "quds",
    labelAr: "القدس",
    labelEn: "Jerusalem",
  },
];

export function deliveryRegionLabel(regionKey, language = "ar") {
  const row = DELIVERY_REGIONS.find((r) => r.key === regionKey);
  if (!row) return regionKey || "";
  return language === "ar" ? row.labelAr : row.labelEn;
}

export function defaultDeliveryPricesMap() {
  return {
    west_bank: 0,
    inside: 0,
    jerusalem: 0,
    abu_ghosh: 0,
    eilat: 0,
    quds: 0,
  };
}
